module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "left-title1"
  }, [_vm._v(_vm._s(_vm.$t('menu_product_left')))]), _vm._v(" "), _c('div', {
    staticClass: "left-panel1",
    staticStyle: {
      "border-top": "1px solid #e2e6eb"
    }
  }, [_c('div', [_c('div', {
    staticClass: "panel-title",
    on: {
      "click": function($event) {
        return _vm.jump('1')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('menu_product_1')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "left-panel1"
  }, [_c('div', [_c('div', {
    staticClass: "panel-title",
    on: {
      "click": function($event) {
        return _vm.jump('2')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('menu_product_2')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "left-panel1 panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab",
      "id": "heading3"
    }
  }, [_c('div', {
    staticClass: "panel-title",
    on: {
      "click": function($event) {
        return _vm.jump('3')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('menu_product_3')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "left-panel1 panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab",
      "id": "heading7"
    }
  }, [_c('div', {
    staticClass: "panel-title",
    on: {
      "click": function($event) {
        return _vm.jump('4')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('menu_product_4')))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px",
      "background": "#e1e1e1",
      "padding-left": "15px",
      "height": "50px",
      "line-height": "50px"
    }
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab",
      "id": "heading6"
    }
  }, [_c('div', {
    staticClass: "panel-title",
    staticStyle: {
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('left_q_title')))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#f1f1f1",
      "padding": "0px 15px"
    }
  }, [_c('div', {
    staticClass: "sub-panel1",
    on: {
      "click": function($event) {
        return _vm.jump1()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('left_q_1')))]), _vm._v(" "), _c('div', {
    staticClass: "sub-panel1",
    on: {
      "click": function($event) {
        return _vm.jump1()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('left_q_2')))]), _vm._v(" "), _c('div', {
    staticClass: "sub-panel1",
    on: {
      "click": function($event) {
        return _vm.jump1()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('left_q_3')))]), _vm._v(" "), _c('div', {
    staticClass: "sub-panel1",
    on: {
      "click": function($event) {
        return _vm.jump1()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('left_q_4')))]), _vm._v(" "), _c('div', {
    staticClass: "sub-panel1",
    staticStyle: {
      "border": "none"
    },
    on: {
      "click": function($event) {
        return _vm.jump1()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('left_q_5')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66c7a2d3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/left.vue
// module id = 1395
// module chunks = 1